export default "__VITE_ASSET__CQYfu3yX__"